// extracted by css-extract-rspack-plugin
export default {"tabPanel":"_6c97a9ff"};